import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PurchaseFlowModule } from '@scaliolabs/baza-web-purchase-flow';
import { PurchaseCustomComponent } from './purchase-custom.component';
import { PurchaseRoutingCustomModule } from './purchase-routing-custom.module';
import { VerificationStateModule } from '@scaliolabs/baza-web-verification-flow';

@NgModule({
    declarations: [PurchaseCustomComponent],
    imports: [CommonModule, PurchaseFlowModule, PurchaseRoutingCustomModule, VerificationStateModule],
    exports: [],
    providers: [],
})
export class PurchaseModule {}
